import {StyleSheet} from 'react-native';
import {FixedValue} from '../../constants';
import {scaleHeight} from '../../utils/responsive';

export const styles = StyleSheet.create({
  contentContainerStyle: {
    paddingTop: scaleHeight(FixedValue.CONSTANT_VALUE_15),
  },
});
